export default (opts = {}) => ({
    swiper: null,
    loop: opts.loop ?? false,

    init() {
        this.$nextTick(() => this.initSwiper());
    },

    initSwiper() {
        const swiperEl = this.$refs.relatedSwiper;
        const prevBtn = this.$refs.relatedPrev;
        const nextBtn = this.$refs.relatedNext;
        if (!swiperEl || !window.Swiper) return;

        this.swiper = new Swiper(swiperEl, {
            slidesPerView: 3,
            spaceBetween: 8,
            pagination: false,
            loop: this.loop,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            breakpoints: {
                320: {slidesPerView: 2.5},
                480: {slidesPerView: 2},
                640: {slidesPerView: 3},
                1024: {slidesPerView: 4},
            },
            keyboard: {enabled: true},
        });
    },
});
